<template>
  <div class="loading" v-show="$bus.loading.show" :class="$bus.loading.opacity ? 'opacity': ''">
    <svg
      class="spinner"
      width="65px"
      height="65px"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="path"
        fill="none"
        stroke-width="6"
        stroke-linecap="round"
        cx="33"
        cy="33"
        r="30"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'loading'
}
</script>

<style>
.loading {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-color: #111620;
}
.loading.opacity {
  background-color: rgba(0, 0, 0, 0);
}
.spinner {
  width: 8.6957vh;
  height: 8.6957vh;
  animation: rotator 1.4s linear infinite;
}
.path {
  stroke-dasharray: 187;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: dash 1.4s ease-in-out infinite, colors 1.4s ease-in-out infinite;
}
@keyframes rotator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
}
@keyframes colors {
  0% {
    stroke: #f3e47e;
  }
  100% {
    stroke: #E0D16A;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 187;
  }
  50% {
    stroke-dashoffset: 47;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 187;
    transform: rotate(450deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/loading/index.vue